import React from 'react';

interface PodcastCategoryType {
  category: string;
  categoryId: string;
}

interface CategoryHeaderProps {
  category: PodcastCategoryType;
  onClick?: (id: PodcastCategoryType) => void;
}

const CategoryHeader: React.FC<CategoryHeaderProps> = ({
  category,
  onClick
}) => {
  return (
    <div className="divider-line" >
      <div
        className="cat-name"
        onClick={onClick ? () => onClick(category) : undefined}
        data-toggle="tooltip"
        data-placement="bottom"
        title={`Search for ${category.category}`}
      >
        {category.category}
      </div>
    </div>
  );
};

export default CategoryHeader;
